import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestApiClient {

  constructor(private httpClient: HttpClient) { }

  /**
   * DELETES-REMOVES request associated with the given Guid
   * @param requestGuid 
   * @returns 
   */
  deleteRequest(requestGuid: string) {
    return this.httpClient.delete(environment.apiUrl + "/requests/" + requestGuid + "");
  }

  async downloadRequest(dossierId: string) {
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/Download", { observe: 'response', responseType: 'blob' });
  }

  async purgeRequest(dossierId: string) {
    let headers = new Headers();
    return this.httpClient.patch(environment.apiUrl + "/requests/" + dossierId + "", { headers: headers });
  }

  restoreRequest(dossierId: string, name: string) {
    return this.httpClient.patch(environment.apiUrl + "/requests/" + dossierId + "/Unrecycle", { "name": name });
  }
  extendDeadlinesIfNeeded(requestGuid: string) {
    return this.httpClient.post(environment.apiUrl + "/requests/" + requestGuid + "/ExtendCleanupDeadlines", {});
  }

  getPaymentUrl(requestGuid: string) {
    return this.httpClient.post(environment.apiUrl + "/requests/" + requestGuid + "/GetPaymentUrl", {}, { responseType: 'text' })
  }
}